import { render, staticRenderFns } from "./user_invite_dialog.vue?vue&type=template&id=76c13322&scoped=true"
import script from "./user_invite_dialog.vue?vue&type=script&lang=ts"
export * from "./user_invite_dialog.vue?vue&type=script&lang=ts"
import style0 from "./user_invite_dialog.vue?vue&type=style&index=0&id=76c13322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c13322",
  null
  
)

export default component.exports